<main
  class="
    tw-grid tw-min-h-full tw-place-items-center  tw-px-6 tw-py-24
    sm:tw-py-32
    lg:tw-px-8
  "
>
  <div class="tw-text-center">
    <p class="tw-text-8xl tw-text-heading tw-font-semibold tw-text-[#111827]">{{ errorConfig.status }}</p>
    <h1
      class="
        tw-mt-4
        text-5xl
        tw-font-semibold tw-tracking-tight tw-text-balance tw-text-gray-900
        sm:tw-text-7xl
      "
    >
      {{ errorConfig.title }}
    </h1>
    <p
      class="
        tw-mt-6 tw-text-lg tw-font-medium tw-text-pretty tw-text-gray-500
        sm:tw-text-xl/8
      "
    >
      {{ errorConfig.message }}
    </p>
    <div class="tw-mt-10 tw-flex tw-items-center tw-justify-center tw-gap-x-6">
      <button
        mat-raised-button
        class="
          tw-rounded-md
          tw-bg-indigo-600
          tw-px-3.5
          tw-py-2.5
          tw-text-sm
          tw-font-semibold
          tw-text-white
          tw-shadow-xs
          hover:tw-bg-indigo-500
        "
        (click)="goHome()"
      >Inicio
      </button
      >
    </div>
  </div>
</main>
